var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.quotationDetail.visible ||
                [
                  _vm.SystemConstants.QUOTATION_TYPE_PRE_PORT.code,
                  _vm.SystemConstants.QUOTATION_TYPE_LAST_MILE.code
                ].indexOf(_vm.quotationType) === -1,
              expression:
                "!quotationDetail.visible || [SystemConstants.QUOTATION_TYPE_PRE_PORT.code, SystemConstants.QUOTATION_TYPE_LAST_MILE.code].indexOf(quotationType) === -1"
            }
          ],
          staticClass: "main-content"
        },
        [
          _c("div", { staticStyle: { width: "100%", "padding-top": "5px" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showSimple,
                    expression: "showSimple"
                  }
                ],
                staticClass: "cargo-advance-search-header"
              },
              [
                _c(
                  "div",
                  { staticClass: "cargo-advance-search-toggle-trigger" },
                  [
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showAdv,
                          expression: "showAdv"
                        }
                      ],
                      staticClass: "el-icon-arrow-left",
                      style: {
                        transform: !_vm.isShowingMoreSearchCondition
                          ? "rotate(-90deg)"
                          : "rotate(90deg)"
                      },
                      on: { click: _vm.upOrDownSearchCondition }
                    })
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.showSimple && !_vm.isShowingMoreSearchCondition,
                        expression:
                          "showSimple && !isShowingMoreSearchCondition"
                      }
                    ],
                    staticClass: "cargo-advance-search-quick"
                  },
                  [
                    _c("el-input", {
                      ref: "keyword",
                      staticStyle: { width: "200px" },
                      attrs: {
                        no: "keyWords",
                        placeholder: _vm.simQueryPlaceholder,
                        spellcheck: false
                      },
                      on: { blur: _vm.keyWordBlur },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.toQuery($event)
                        }
                      },
                      model: {
                        value: _vm.keyWords,
                        callback: function($$v) {
                          _vm.keyWords = $$v
                        },
                        expression: "keyWords"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    ref: "searchOperations",
                    staticClass: "cargo-advance-search-operations"
                  },
                  [
                    _vm._t("operations", [
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { no: "toQuery", type: "primary" },
                              on: { click: _vm.toQuery }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "resetSearch", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.resetSearch()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Reset")))]
                          ),
                          !_vm.isPrePortOrLastMile
                            ? _c(
                                "el-button",
                                {
                                  attrs: { no: "onCopy", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onCopy()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("Pricing.Copy")))]
                              )
                            : _vm._e(),
                          _vm.inputAllowed
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "inputAllowed",
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onQuotation()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                              )
                            : _vm._e(),
                          _vm.isDelete
                            ? _c(
                                "el-button",
                                {
                                  attrs: { no: "isDelete", type: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onDelete()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Delete"))
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ],
                  2
                )
              ]
            ),
            _vm.showAdv
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isShowingMoreSearchCondition,
                        expression: "isShowingMoreSearchCondition"
                      }
                    ],
                    staticClass: "cargo-advance-search-more"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "cargo-advance-search-more-operations" },
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              "label-width": "60px",
                              "label-position": "left",
                              inline: true
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: _vm.$t("Pricing.QuotationNo") }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "190px" },
                                  attrs: { no: "quotationNo" },
                                  model: {
                                    value: _vm.filter.quotationNo,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "quotationNo", $$v)
                                    },
                                    expression: "filter.quotationNo"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("Pricing.POL") } },
                              [
                                _vm.quotationType !=
                                _vm.PriceConstant.QUOTATION_AIR
                                  ? _c("cargo-advance-select", {
                                      staticStyle: { width: "190px" },
                                      attrs: {
                                        no: "pol",
                                        filterable: "",
                                        placeholder: _vm.$t(
                                          "Pricing.POLPrompt"
                                        ),
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_Seaport,
                                        "custom-label": function(item) {
                                          return (
                                            "[" +
                                            item.code +
                                            "]" +
                                            item.englishName
                                          )
                                        },
                                        "filter-tag-names": [
                                          "code",
                                          "englishName"
                                        ],
                                        "show-custom-label-in-option": true,
                                        "default-value": _vm.filter.pol
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.filter.pol = p.value
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm.quotationType ==
                                _vm.PriceConstant.QUOTATION_AIR
                                  ? _c("cargo-advance-select", {
                                      staticStyle: { width: "190px" },
                                      attrs: {
                                        no: "pol1",
                                        filterable: "",
                                        placeholder: _vm.$t(
                                          "Pricing.POLPrompt"
                                        ),
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_Airport,
                                        "custom-label": function(item) {
                                          return (
                                            "[" +
                                            item.code +
                                            "]" +
                                            item.englishName
                                          )
                                        },
                                        "filter-tag-names": [
                                          "code",
                                          "englishName"
                                        ],
                                        "show-custom-label-in-option": true,
                                        "default-value": _vm.filter.pol
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.filter.pol = p.value
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("Pricing.POD") } },
                              [
                                _vm.quotationType !=
                                _vm.PriceConstant.QUOTATION_AIR
                                  ? _c("cargo-advance-select", {
                                      staticStyle: { width: "190px" },
                                      attrs: {
                                        no: "pod",
                                        filterable: "",
                                        placeholder: _vm.$t(
                                          "Pricing.PODPrompt"
                                        ),
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_Seaport,
                                        "custom-label": function(item) {
                                          return (
                                            "[" +
                                            item.code +
                                            "]" +
                                            item.englishName
                                          )
                                        },
                                        "filter-tag-names": [
                                          "code",
                                          "englishName"
                                        ],
                                        "show-custom-label-in-option": true,
                                        "default-value": _vm.filter.pod
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.filter.pod = p.value
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm.quotationType ==
                                _vm.PriceConstant.QUOTATION_AIR
                                  ? _c("cargo-advance-select", {
                                      staticStyle: { width: "190px" },
                                      attrs: {
                                        no: "pod1",
                                        filterable: "",
                                        placeholder: _vm.$t(
                                          "Pricing.PODPrompt"
                                        ),
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_Airport,
                                        "custom-label": function(item) {
                                          return (
                                            "[" +
                                            item.code +
                                            "]" +
                                            item.englishName
                                          )
                                        },
                                        "filter-tag-names": [
                                          "code",
                                          "englishName"
                                        ],
                                        "show-custom-label-in-option": true,
                                        "default-value": _vm.filter.pod
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.filter.pod = p.value
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100px" },
                                    attrs: { no: "ddlClientType" },
                                    model: {
                                      value: _vm.filter.ddlClientType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filter,
                                          "ddlClientType",
                                          $$v
                                        )
                                      },
                                      expression: "filter.ddlClientType"
                                    }
                                  },
                                  _vm._l(
                                    _vm.PriceConstant.CLIENT_TYPE_LIST,
                                    function(item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: _vm.isZh
                                            ? item.chineseName
                                            : item.englishName,
                                          value: item.code
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              [
                                _vm.filter.ddlClientType === 1
                                  ? _c("cargo-company-select", {
                                      staticStyle: { width: "190px" },
                                      attrs: {
                                        no: "clientId",
                                        "method-params": {
                                          customer: true,
                                          active: true
                                        },
                                        "default-value":
                                          _vm.filter.clientId || undefined
                                      },
                                      on: {
                                        change: function(p) {
                                          _vm.filter.clientId = p.value
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm.filter.ddlClientType === 0
                                  ? _c("cargo-advance-select", {
                                      staticStyle: { width: "190px" },
                                      attrs: {
                                        no: "clientId1",
                                        "custom-label": function(item) {
                                          return (
                                            "[" +
                                            _vm.branchMap.get(item.branchId) +
                                            "]" +
                                            item.name
                                          )
                                        },
                                        "show-custom-label-in-option": true,
                                        filterable: "",
                                        "default-value":
                                          _vm.filter.clientId || undefined,
                                        cache: false,
                                        "tag-name": "name",
                                        "tag-value": "clientId",
                                        "filter-tag-names": ["code", "name"],
                                        "static-options": _vm.filter.clientList
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.filter.clientId = p.value
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("Pricing.Sales") } },
                              [
                                _c("cargo-user-select", {
                                  ref: "salesSelect",
                                  staticStyle: { width: "190px" },
                                  attrs: {
                                    no: "sales",
                                    "method-params": {
                                      officeId:
                                        _vm.$store.getters.currentOfficeId
                                    },
                                    "default-value":
                                      _vm.filter.sales || undefined,
                                    "callback-params": { key: "userId" }
                                  },
                                  on: {
                                    change: function(p) {
                                      _vm.filter.sales = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: _vm.$t("Pricing.CreatedDate") }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "190px" },
                                  attrs: {
                                    no: "beginDate",
                                    type: "date",
                                    "value-format": "yyyy-MM-dd"
                                  },
                                  model: {
                                    value: _vm.filter.beginDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "beginDate", $$v)
                                    },
                                    expression: "filter.beginDate"
                                  }
                                }),
                                _vm._v(
                                  " " + _vm._s(_vm.$t("Pricing.EndDate")) + " "
                                ),
                                _c("el-date-picker", {
                                  staticStyle: { width: "190px" },
                                  attrs: {
                                    no: "endDate",
                                    type: "date",
                                    "value-format": "yyyy-MM-dd"
                                  },
                                  model: {
                                    value: _vm.filter.endDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "endDate", $$v)
                                    },
                                    expression: "filter.endDate"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("Pricing.IsBooked"),
                                  "label-width": "180"
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "140px" },
                                    attrs: { no: "ddlIsBooked" },
                                    model: {
                                      value: _vm.filter.ddlIsBooked,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "ddlIsBooked", $$v)
                                      },
                                      expression: "filter.ddlIsBooked"
                                    }
                                  },
                                  _vm._l(
                                    _vm.PriceConstant.CLIENT_IS_BOOKED_LIST,
                                    function(item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: _vm.isZh
                                            ? item.chineseName
                                            : item.englishName,
                                          value: item.code
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("Pricing.BeginDate") } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "180px" },
                                  attrs: {
                                    no: "beginDateCol",
                                    type: "date",
                                    "picker-options": {
                                      disabledDate: function(time) {
                                        return (
                                          time.getTime() >
                                          new Date(
                                            _vm.filter.endDateCol + " 23:59:59"
                                          ).getTime()
                                        )
                                      }
                                    },
                                    "value-format": "yyyy-MM-dd"
                                  },
                                  model: {
                                    value: _vm.filter.beginDateCol,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "beginDateCol", $$v)
                                    },
                                    expression: "filter.beginDateCol"
                                  }
                                }),
                                _c("span", { staticStyle: { margin: "5px" } }, [
                                  _vm._v(_vm._s(_vm.$t("Pricing.EndDate")))
                                ]),
                                _c("el-date-picker", {
                                  staticStyle: { width: "180px" },
                                  attrs: {
                                    no: "endDateCol",
                                    type: "date",
                                    "picker-options": {
                                      disabledDate: function(time) {
                                        return (
                                          time.getTime() <
                                          new Date(
                                            _vm.filter.beginDateCol +
                                              " 00:00:00"
                                          ).getTime()
                                        )
                                      }
                                    },
                                    "value-format": "yyyy-MM-dd"
                                  },
                                  model: {
                                    value: _vm.filter.endDateCol,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "endDateCol", $$v)
                                    },
                                    expression: "filter.endDateCol"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_amount")
                                }
                              },
                              [
                                _c("el-input-number", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    no: "limited",
                                    min: 300,
                                    max: 3000,
                                    precision: 0,
                                    "controls-position": "right"
                                  },
                                  on: { blur: _vm.selectBlur },
                                  model: {
                                    value: _vm.limited,
                                    callback: function($$v) {
                                      _vm.limited = $$v
                                    },
                                    expression: "limited"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_EnquiryNumber")
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "190px" },
                                  attrs: { no: "inquiryPriceNo" },
                                  model: {
                                    value: _vm.filter.inquiryPriceNo,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.filter,
                                        "inquiryPriceNo",
                                        $$v
                                      )
                                    },
                                    expression: "filter.inquiryPriceNo"
                                  }
                                })
                              ],
                              1
                            ),
                            [
                              _vm.PriceConstant.QUOTATION_PRE_PORT,
                              _vm.PriceConstant.QUOTATION_LAST_MILE
                            ].indexOf(_vm.quotationType) === -1
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "200",
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_AssociatedPrePortQuoteNumber"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "190px" },
                                      attrs: { no: "prePortQuotationNo" },
                                      model: {
                                        value: _vm.filter.prePortQuotationNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter,
                                            "prePortQuotationNo",
                                            $$v
                                          )
                                        },
                                        expression: "filter.prePortQuotationNo"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            [
                              _vm.PriceConstant.QUOTATION_PRE_PORT,
                              _vm.PriceConstant.QUOTATION_LAST_MILE
                            ].indexOf(_vm.quotationType) === -1
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "200",
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_AssociatedLastMileQuoteNumber"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "190px" },
                                      attrs: { no: "lastMileQuotationNo" },
                                      model: {
                                        value: _vm.filter.lastMileQuotationNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter,
                                            "lastMileQuotationNo",
                                            $$v
                                          )
                                        },
                                        expression: "filter.lastMileQuotationNo"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("FbaJob.quotationStatus"),
                                  "label-width": "180"
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "140px" },
                                    attrs: { no: "status2", clearable: "" },
                                    on: {
                                      clear: function($event) {
                                        _vm.filter.status2 = null
                                      }
                                    },
                                    model: {
                                      value: _vm.filter.status2,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "status2", $$v)
                                      },
                                      expression: "filter.status2"
                                    }
                                  },
                                  _vm._l(
                                    _vm.SystemConstants.QUOTE_STATUS,
                                    function(item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: _vm.isZh
                                            ? item.chineseName
                                            : item.englishName,
                                          value: item.code
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_QuoteMethod"),
                                  "label-width": "180"
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "140px" },
                                    attrs: {
                                      no: "quotationMethod",
                                      clearable: ""
                                    },
                                    on: {
                                      clear: function($event) {
                                        _vm.filter.quotationMethod = null
                                      }
                                    },
                                    model: {
                                      value: _vm.filter.quotationMethod,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filter,
                                          "quotationMethod",
                                          $$v
                                        )
                                      },
                                      expression: "filter.quotationMethod"
                                    }
                                  },
                                  _vm._l(
                                    _vm.SystemConstants.QUOTATION_METHODS,
                                    function(item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: _vm.isZh
                                            ? item.chineseName
                                            : item.englishName,
                                          value: item.code
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ]),
          _c(
            "cargo-left-right-resize",
            {
              staticStyle: { height: "100%" },
              attrs: {
                "left-style": {
                  display: "flex",
                  flexDirection: "column",
                  width: _vm.isPrePortOrLastMile ? "100%" : "60%"
                },
                "right-style": {
                  display: "flex",
                  flexDirection: "column",
                  width: _vm.isPrePortOrLastMile ? "0%" : "40%"
                }
              }
            },
            [
              _c("template", { slot: "left" }, [
                _c(
                  "div",
                  {
                    staticClass: "section grid-wrapper",
                    staticStyle: { "min-height": "350px" }
                  },
                  [
                    _c("cargo-ag-grid", {
                      key: "22020200" + _vm.quotationType,
                      staticStyle: { flex: "1" },
                      attrs: {
                        "config-module": "22020200" + _vm.quotationType,
                        "grid-params": _vm.gridParams,
                        "grid-options": _vm.gridOptions,
                        "column-defs": _vm.columnDefs,
                        "row-data": _vm.rowData
                      },
                      on: {
                        "update:gridParams": function($event) {
                          _vm.gridParams = $event
                        },
                        "update:grid-params": function($event) {
                          _vm.gridParams = $event
                        },
                        gridReady: _vm.onGridReady
                      }
                    })
                  ],
                  1
                )
              ]),
              !_vm.isPrePortOrLastMile
                ? _c("template", { slot: "right" }, [
                    _c(
                      "div",
                      {
                        staticClass: "section grid-wrapper",
                        staticStyle: { "min-height": "350px" }
                      },
                      [
                        _vm.quotationType === _vm.PriceConstant.QUOTATION_FCL
                          ? _c("cargo-ag-grid", {
                              key: "22020201",
                              staticStyle: { flex: "1" },
                              attrs: {
                                "config-module": "22020201",
                                "grid-params": _vm.fcl.gridParams,
                                "grid-options": _vm.fcl.gridOptions,
                                "column-defs": _vm.fcl.columnDefs,
                                "row-data": _vm.fcl.rowData
                              },
                              on: {
                                "update:gridParams": function($event) {
                                  return _vm.$set(_vm.fcl, "gridParams", $event)
                                },
                                "update:grid-params": function($event) {
                                  return _vm.$set(_vm.fcl, "gridParams", $event)
                                },
                                gridReady: _vm.onFclGridReady
                              }
                            })
                          : _vm._e(),
                        _vm.quotationType === _vm.PriceConstant.QUOTATION_LCL
                          ? _c("cargo-ag-grid", {
                              key: "22020202",
                              staticStyle: { flex: "1" },
                              attrs: {
                                "config-module": "22020202",
                                "grid-params": _vm.lcl.gridParams,
                                "grid-options": _vm.lcl.gridOptions,
                                "column-defs": _vm.lcl.columnDefs,
                                "row-data": _vm.lcl.rowData
                              },
                              on: {
                                "update:gridParams": function($event) {
                                  return _vm.$set(_vm.lcl, "gridParams", $event)
                                },
                                "update:grid-params": function($event) {
                                  return _vm.$set(_vm.lcl, "gridParams", $event)
                                },
                                gridReady: _vm.onLclGridReady
                              }
                            })
                          : _vm._e(),
                        _vm.quotationType === _vm.PriceConstant.QUOTATION_AIR
                          ? _c("cargo-ag-grid", {
                              key: "22020203",
                              staticStyle: { flex: "1" },
                              attrs: {
                                "config-module": "22020203",
                                "grid-params": _vm.air.gridParams,
                                "grid-options": _vm.air.gridOptions,
                                "column-defs": _vm.air.columnDefs,
                                "row-data": _vm.air.rowData
                              },
                              on: {
                                "update:gridParams": function($event) {
                                  return _vm.$set(_vm.air, "gridParams", $event)
                                },
                                "update:grid-params": function($event) {
                                  return _vm.$set(_vm.air, "gridParams", $event)
                                },
                                gridReady: _vm.onAirGridReady
                              }
                            })
                          : _vm._e(),
                        _vm.quotationType ===
                        _vm.PriceConstant.QUOTATION_PRE_PORT
                          ? _c("cargo-ag-grid", {
                              key: "22020531",
                              staticStyle: { flex: "1" },
                              attrs: {
                                "config-module": "22020531",
                                "grid-params": _vm.prePort.gridParams,
                                "grid-options": _vm.prePort.gridOptions,
                                "column-defs": _vm.prePort.columnDefs,
                                "row-data": _vm.prePort.rowData
                              },
                              on: {
                                "update:gridParams": function($event) {
                                  return _vm.$set(
                                    _vm.prePort,
                                    "gridParams",
                                    $event
                                  )
                                },
                                "update:grid-params": function($event) {
                                  return _vm.$set(
                                    _vm.prePort,
                                    "gridParams",
                                    $event
                                  )
                                },
                                gridReady: _vm.onPrePortGridReady
                              }
                            })
                          : _vm._e(),
                        _vm.quotationType ===
                        _vm.PriceConstant.QUOTATION_LAST_MILE
                          ? _c("cargo-ag-grid", {
                              key: "22020532",
                              staticStyle: { flex: "1" },
                              attrs: {
                                "config-module": "22020532",
                                "grid-params": _vm.lastMile.gridParams,
                                "grid-options": _vm.lastMile.gridOptions,
                                "column-defs": _vm.lastMile.columnDefs,
                                "row-data": _vm.lastMile.rowData
                              },
                              on: {
                                "update:gridParams": function($event) {
                                  return _vm.$set(
                                    _vm.lastMile,
                                    "gridParams",
                                    $event
                                  )
                                },
                                "update:grid-params": function($event) {
                                  return _vm.$set(
                                    _vm.lastMile,
                                    "gridParams",
                                    $event
                                  )
                                },
                                gridReady: _vm.onLastMileGridReady
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            2
          ),
          _c("div", { staticClass: "pagination-wrapper" }, [
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  staticStyle: { "text-align": "left" },
                  attrs: { total: _vm.total, layout: "total" }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm.quotationDetail.visible &&
      [
        _vm.SystemConstants.QUOTATION_TYPE_PRE_PORT.code,
        _vm.SystemConstants.QUOTATION_TYPE_LAST_MILE.code
      ].indexOf(_vm.quotationType) === -1
        ? _c("quotation-detail-dialog", {
            attrs: {
              visible: _vm.quotationDetail.visible,
              model: _vm.quotationDetail.quotation,
              editing: _vm.quotationDetail.isEditing,
              "show-quotation-detail": _vm.quotationDetail.showDetail,
              "is-edit-all": _vm.isEditAll
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.quotationDetail, "visible", $event)
              },
              saveSuccess: _vm.saveSuccess
            }
          })
        : _vm._e(),
      _vm.quotationDetail.visible &&
      _vm.SystemConstants.QUOTATION_TYPE_PRE_PORT.code === _vm.quotationType
        ? _c("quotation-pre-port-detail", {
            ref: "quotationDetail",
            attrs: { "is-edit-all": _vm.isEditAll },
            on: {
              cancel: function($event) {
                _vm.quotationDetail.visible = false
              },
              back: function($event) {
                _vm.quotationDetail.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.quotationDetail.visible &&
      _vm.SystemConstants.QUOTATION_TYPE_LAST_MILE.code === _vm.quotationType
        ? _c("quotation-last-mile-detail", {
            ref: "quotationDetail",
            attrs: { "is-edit-all": _vm.isEditAll },
            on: {
              cancel: function($event) {
                _vm.quotationDetail.visible = false
              },
              back: function($event) {
                _vm.quotationDetail.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }